/** @format */
import { Taxonomy } from '@toucan/types/mpbx/taxonomy';

import { client } from '@toucan/services/request-client';

export async function getCategoryTree(): Promise<Taxonomy> {
    const response = await client.get('/taxonomy/category');
    return response.data;
}

export async function getBrandTree(): Promise<Taxonomy> {
    const response = await client.get('/taxonomy/brand');
    return response.data;
}
